import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail", "chevron"]

  toggle(event) {
    event.preventDefault()
    const expanded = this.chevronTarget.getAttribute("aria-expanded") === "true"
    this.detailTarget.hidden = expanded
    this.chevronTarget.setAttribute("aria-expanded", (!expanded).toString())
    this.chevronTarget.textContent = expanded ? "▸" : "▾"
  }
}
